import React from "react";
import Banner from "../../../components/Banner";
import ClassroomCard from "../../../components/ClassroomCard";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { clearRedirect } from "../../../redux/actions/redirect";

import { Col, Container, Button, Row } from "reactstrap";

const PremiumClassrooms = () => {
  const buttonText = "입장하기";
  const classrooms = [
    {
      title: "수학 방",
      description: "수학 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "maths.png",
      href_link: "",
    },
    {
      title: "경제 방",
      description: "경제 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "money.png",
      href_link: "",
    },
    {
      title: "물리 방",
      description: "물리 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "elon_musk.png",
      href_link: "",
    },
    {
      title: "화학 방",
      description: "화학 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "card2.png",
      href_link: "",
    },
    {
      title: "생물 방",
      description: "생물 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "cosmetics3.png",
      href_link: "",
    },
    {
      title: "컴퓨터 공학 방",
      description: "컴퓨터 공학 강의를 들을 수 있는 방입니다",
      buttonText: buttonText,
      img: "ethereum.png",
      href_link: "",
    },
  ];

  const authData = useSelector((state) => state.google_auth);

  if (!authData.isSignedIn) {
    let redirect_path = "/auth/oauth_login";
    clearRedirect();
    return <Redirect to={redirect_path} />;
  }

  return (
    <React.Fragment>
      <Banner title="1:1 Premium Classrooms" bg="classroom_banner.jpg" />
      <Container className="subject_container">
        <h2>방 목록</h2>
        <Row mb={3}>
          {classrooms.map((classroom, index) => {
            return (
              <Col md={4} sm={12}>
                <ClassroomCard
                  title={classroom.title}
                  description={classroom.description}
                  buttonText={classroom.buttonText}
                  img={classroom.img}
                  href_link={classroom.href_link}
                />
              </Col>
            );
          })}
        </Row>
        <hr className="mt-4 mb-4" />
      </Container>
    </React.Fragment>
  );
};

export default PremiumClassrooms;
